"use client";

import { createListCollection } from "@chakra-ui/react";
import { useMemo } from "react";
import { type Situation } from "@/generated/fastapi";

export default function useSituationOptions(situations?: Situation[]) {
  return useMemo(() => {
    if (!situations?.length) {
      return createListCollection({ items: [] as Situation[] });
    }

    return createListCollection({
      items: situations,
      itemToString: (item) =>
        (item.abbr as string) || `${item.position} (${item.context})`,
      itemToValue: (item) => item.id as string,
    });
  }, [situations]);
}
